import AscendingK from '../components/AscendingK';
import { Icons } from '../components/Icons';
import { getApiBaseUrl } from '../lib/api';
import { getInitials } from '../utils/validation';

export default function ScanPagePreview({ user }) {
  const visibleLinks = user.links.filter((link) => link.visible);
  const initials = getInitials(user.name);

  const handleSaveContact = () => {
    window.location.href = `${getApiBaseUrl()}/cards/${user.slug || user.name.toLowerCase().replace(/\s+/g, '-')}/vcard`;
  };

  return (
    <>
      <div className="page-header">
        <div className="mono" style={{ marginBottom: 8 }}>Preview</div>
        <h1 className="page-title">
          Your scan <em>page</em>.
        </h1>
        <p className="page-subtitle">This is what people see when they scan your QR code.</p>
      </div>

      <div className="page-body">
        <div className="scan-preview-frame animate-fadeUp">
          <div className="scan-header">
            <div className="scan-avatar">
              {user.photo ? <img src={user.photo} alt={user.name} /> : <span className="initials">{initials}</span>}
            </div>
            <div className="scan-user-info">
              <div className="scan-name">{user.name || 'Your Name'}</div>
              {user.title && (
                <div className="scan-role">
                  {user.title}
                  {user.company ? ` - ${user.company}` : ''}
                </div>
              )}
              {user.tagline && <div className="scan-company">{user.tagline}</div>}
            </div>
          </div>

          {user.about && <div className="scan-about">{user.about}</div>}

          <div className="scan-actions">
            <button className="scan-action-primary" onClick={handleSaveContact}>
              {Icons.save} Save my contact
            </button>
            {user.whatsapp && (
              <a
                href={`https://wa.me/${user.whatsapp.replace(/[^\d+]/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="scan-action-wa"
                style={{ textDecoration: 'none' }}
              >
                {Icons.whatsapp} Say Hi on WhatsApp
              </a>
            )}
          </div>

          <div className="scan-secondary">
            {user.phone && (
              <a href={`tel:${user.phone}`} className="scan-btn-sec" style={{ textDecoration: 'none' }}>
                <span className="sc-label">Call</span>
                <span className="sc-value">{user.phone}</span>
              </a>
            )}
            {user.email && (
              <a href={`mailto:${user.email}`} className="scan-btn-sec" style={{ textDecoration: 'none' }}>
                <span className="sc-label">Email</span>
                <span className="sc-value">{user.email}</span>
              </a>
            )}
          </div>

          {visibleLinks.length > 0 && (
            <div className="scan-links">
              {visibleLinks.map((link) => (
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="scan-link-row"
                  key={link.id}
                  style={{ textDecoration: 'none' }}
                >
                  <span className="scan-link-label">{link.platform}</span>
                  <span className="scan-link-value">Open &rarr;</span>
                </a>
              ))}
            </div>
          )}

          <div className="scan-footer">
            <AscendingK size={12} color="#B8B2A2" />
            <span className="scan-footer-text">Powered by Connekted in</span>
          </div>
        </div>
      </div>
    </>
  );
}
